import { CommonModule } from '@angular/common';
import { Component, EventEmitter, input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { TranslocoModule } from '@jsverse/transloco';

import {
	PrismButtonComponent,
	PrismIconComponent,
	PrismMenuComponent,
	PrismMenuItemComponent
} from '@shure/prism-angular-components';
import { PrismButtonVariant } from '@shure/prism-web-components';

import { ExportFileType } from '../ag-grid-utils';

@Component({
	selector: 'sh-export-button',
	imports: [
		CommonModule,
		MatMenuModule,
		MatIconModule,
		TranslocoModule,
		PrismButtonComponent,
		PrismIconComponent,
		PrismMenuComponent,
		PrismMenuItemComponent
	],
	templateUrl: './export-button.component.html',
	styleUrls: ['./export-button.component.scss']
})
export class ExportButtonComponent {
	@Output() public exportFile = new EventEmitter<ExportFileType>();
	public buttonDisabled = input<boolean | null>();
	public buttonTooltip = input<string>();
	public buttonVariant = input<PrismButtonVariant>(PrismButtonVariant.Standard);

	public exportFileTypes = Object.values(ExportFileType);

	/**
	 * emit exportFile event
	 * @param type represent type of export files
	 */
	public exportData(type: ExportFileType): void {
		this.exportFile.emit(type);
	}
}
